import React, {useEffect, useState} from 'react'
import moment from "moment";
import {message, Pagination, Spin} from "antd"
import parseToken from "../../../helpers/parseToken";
import {formatDate3} from "../../../helpers/formatDate";
import {getUserDataLevel} from "../../../services/api/apiLead";
import ReportDetailSubSearch from "./search/ReportDetailSubSearch";
import {reportBenefit} from "../../../services/api/apiReport2";
import {searchTenant} from "../../../services/api/apiUser";
import Export from "./actions/Export";

const ReportBenefitPage = () => {
    const [level, setLevel] = useState(0)
    const [showFilter, setShowFilter] = useState(true)
    const [filters, setFilters] = useState({
        fromDate: moment().subtract(1, 'months').startOf('day'),
        toDate: moment().endOf('day'),
        tenantId: [],
        page: "1",
        pagesize: "1000"
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [tenants, setTenants] = useState([])
    const [total, setTotal] = useState(0)
    const info = parseToken()

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _onChangeFilters = (name, value) => {
        setFilters({
            ...filters,
            [name]: value,
            page: 1
        })
    }

    const _onChangeDateFrom = (value) => {
        setFilters({
            ...filters,
            fromDate: value,
            page: 1
        })
    }

    const _onChangeDateTo = (value) => {
        setFilters({
            ...filters,
            toDate: value,
            page: 1
        })
    }

    const _fetchListReportBenefit = async (levelInit = 0) => {
        setLoading(true)
        setError('')

        try {
            const decodeToken = parseToken()
            const payload = {
                ...filters,
                tenantId: filters.tenantId.join(','),
                level: levelInit ? levelInit : level,
                fromDate: formatDate3(filters.fromDate) + ' 00:00:00',
                toDate: formatDate3(filters.toDate) + ' 23:59:00',
                userName: decodeToken.sub,
                pagesize: filters.pagesize + '',
                page: filters.page + ''
            }
            const response = await reportBenefit(payload);
            const {headers, data} = response
            const contentResponse = JSON.parse(headers["content-response"])

            setTotal(contentResponse.data)
            document.getElementById('ReportBenefitElm').innerHTML = data.replaceAll('file:/u02/ipcc/report/services-report/./../../omap/IPCCMedia/webapps/IPCCMedia/images', import.meta.env.REACT_APP_LINK_SVG_CHART || 'https://103.116.106.115:1770/IPCCMedia/images')
            setLoading(false)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _fetchListTenant = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }

            const response = await searchTenant(payload, info.sub)

            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _tenants = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.id,
                }
            })

            setTenants([..._tenants])
            if (_tenants.length === 1) {
                setFilters({
                    ...filters,
                    tenantId: _tenants[0].value + ''
                })
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    const _getUserDataLevel = async () => {
        try {
            const payload = {
                userName: info.sub,
                dataObject: "REPORT",
                dataAction: "VIEW"
            }

            const {data} = await getUserDataLevel(payload)

            const {success, datalevel} = data

            if (parseInt(success) !== 1) {
                return
            }

            setLevel(datalevel)
        } catch (e) {

        }
    }

    const _onChangePagination = (page, pageSize) => {
        setFilters({
            ...filters,
            pagesize: pageSize,
            page: page
        })
    }

    useEffect(() => {
        _getUserDataLevel()
        _fetchListTenant()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _fetchListReportBenefit()
        // eslint-disable-next-line
    }, [filters.page])

    return (
        <div className="ReportByDayPage PageDefault">

            <div className="PageHeading">
                <h1 className="PageTitle">Báo cáo hoa hồng sale</h1>
                <div className="PageFilterTop">
                    <div className="FiltersOpen" onClick={_onToggleFilter}>
                        <span className="material-icons Filter">filter_list</span>
                        <label>Bộ lọc</label>
                    </div>
                    <div className='d-flex align-items-center'>
                        <Export filters={filters} tenants={tenants} level={level}/>
                    </div>
                </div>
            </div>
            {
                showFilter && <div className="Filter">
                    <ReportDetailSubSearch
                        tenants={tenants}
                        filters={filters}
                        onChangeFilters={_onChangeFilters}
                        receptionDateFrom={filters.fromDate}
                        receptionDateTo={filters.toDate}
                        onChangeTo={_onChangeDateTo}
                        onChangeFrom={_onChangeDateFrom}
                        fetchListReport={_fetchListReportBenefit}
                    />
                </div>
            }
            <Spin spinning={loading} tip="Đang lấy dữ liệu từ server...">
                <div id="ReportBenefitElm" className="tableReportNormal reportCallFee"></div>
                {total > 0 && (
                    <div className="PagePagination d-flex justify-content-end align-items-center mt-3">
                        <div className="total mr-3">Total {total} items</div>
                        <Pagination
                            className="PaginationCustom"
                            pageSizeOptions={['20', '50', '100', '200']}
                            total={total}
                            showSizeChanger={true}
                            pageSize={parseInt(filters.pagesize)}
                            current={parseInt(filters.page)}
                            onChange={_onChangePagination}
                        />
                    </div>
                )}

                {error && <div className="text-danger mt-3">{error}</div>}
            </Spin>
        </div>
    )
}

export default ReportBenefitPage
